<template>
  <div class="exam-content-rts">
    <div class="title">
      Listen to and read a description of a situation. 
      You wil have 10 seconds to think about your answer. 
      Then you willhear a beep. You wilhave 40 seconds to answer the question, Please answer as completely as you can.
    </div>
    <div class="answer-detail">
      <p>{{ this.detail.content_text }}</p>
    </div>
    <div class="audio">
      <Audio :time="10" :url="detail.audio.url" :onInit="handleAudioInit" />
    </div>
    <div class="record">
      <Record
        ref="record"
        v-if="recoredWaitTime > 0"
        :time="recoredWaitTime"
        :maxTime="40"
        :onUpload="handleUplaod"
        :onTime="handleRecordTime"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Record from '../../components/record'
import Audio from '../../components/audio'
import api from '@/api/exam'

export default {
  components: {
    Record,
    Audio
  },
  props: {
    detail: {
      type: Object,
      default: () => ({})
    },
    examInfo: {
      type: Object,
      default: () => ({})
    },
    itemData: {
      type: Object,
      default: () => ({})
    },
    infoData: {
      type: Object,
      default: () => ({})
    },

    onFinish: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      recoredWaitTime: 0,
      recordCurrentTime: -1
    }
  },
  mounted() {
    this.SetTimeType({ type: 'SPEAK' })
  },
  methods: {
    ...mapActions('exam', ['SetTimeType']),
    submit() {
      if (
        this.recordCurrentTime === 0 &&
        this.$refs.record &&
        this.$refs.record.stop
      ) {
        this.$refs.record.stop()
        return true
      }
      return false
    },

    handleRecordTime(time) {
      this.recordCurrentTime = time
    },

    handleAudioInit(audioTime, waitTime) {
      this.recoredWaitTime = Math.round(audioTime + waitTime) + 10
    },
    async handleUplaod(url) {
      await api.submit({
        my_exam_id: this.examInfo.my_exam_id,
        qid: this.itemData.gre_try_id,
        oss_url: url
      })
      this.onFinish()
    }
  }
}
</script>

<style scoped lang="scss">
.exam-content-rts {
  color: #1f1f40;
  padding-bottom: 24px;
  .title {
    margin-top: 24px;
    font-size: 16px;
    font-weight: bold;
  }
  .record {
    margin-top: 24px;
    display: flex;
    justify-content: center;
  }
  .audio {
    margin-top: 24px;
    display: flex;
    justify-content: center;
  }
  .answer-detail {
    margin: 20px auto;
    padding: 12px 16px;
    width: 777px;
    min-height: 44px;
    background-color: #f6f6f6;
    border-radius: 10px;
    font-size: 18px;
    font-weight: 400;
    line-height: 22px;
    color: #1f1f40;
    .word {
      display: inline-block;
      margin-right: 3px;
    }
  }
}
</style>
